
import { Component, Vue} from "vue-property-decorator";

@Component
export default class MobileInfoWindow extends Vue {
    public async openInfoWindow(id: number) {}
    public async close() {}
}
